module.exports = __webpack_public_path__ + "static/media/snake.4adfc5a7.svg";